import { useRouter } from 'next/router';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import { L as LOGIN, d as ACCOUNT_SETTINGS } from './paths-ZKN3m62_.js';
import './payment-YC9H491Y.js';
import React, { useContext } from 'react';
import RegisterForm from './components/RegisterForm/index.js';
import { RegisterFormType } from './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import './product-_pRduMz7.js';
import './modal-6vnX5SO3.js';
import { validateHCaptchaTokenOnServer } from './utils/captcha.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { CoreContext } from './context/index.js';

const RegisterPage = ({ showHCaptcha }) => {
    const router = useRouter();
    const { data: { siteConfig: { account: { register: { hahSubscribeCheckbox = false, brandSubscribeCheckbox = false, accorSubscribeCheckbox = false, } = {}, } = {}, }, }, } = useContext(CoreContext);
    return (React.createElement("section", { className: "auth-section" },
        React.createElement("div", { className: "auth-container" },
            React.createElement(RegisterForm, { formType: RegisterFormType.Page, siteSubscribeCheckbox: hahSubscribeCheckbox, brandSubscribeCheckbox: brandSubscribeCheckbox, accorSubscribeCheckbox: accorSubscribeCheckbox, validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onBack: () => router.replace(LOGIN), onSubmitted: () => {
                    router.replace(ACCOUNT_SETTINGS);
                }, showHCaptcha: showHCaptcha }))));
};
var RegisterPage$1 = withProviders(RegisterPage, { translation: true });

export { RegisterPage$1 as R };
//# sourceMappingURL=RegisterPage-PJoeEjMv.js.map
